export interface PreviewPoint {
  x: number;
  y: number;
}

export interface BatchPreviewPath {
  sourceNodeId: string;
  d: string;
}

export function canRenderBatchPreview(
  sources: readonly { nodeId: string; point: PreviewPoint }[]
): boolean {
  return sources.length > 0;
}

export function createBatchConnectionPreviewPaths(input: {
  sources: readonly { nodeId: string; point: PreviewPoint }[];
  target: PreviewPoint;
}): BatchPreviewPath[] {
  return input.sources.map(({ nodeId, point }) => {
    const bend = Math.max(54, Math.abs(input.target.x - point.x) * 0.42);
    return {
      sourceNodeId: nodeId,
      d: `M ${point.x} ${point.y} C ${point.x + bend} ${point.y}, ${input.target.x - bend} ${input.target.y}, ${input.target.x} ${input.target.y}`
    };
  });
}
